module.exports = __webpack_public_path__ + "media/images/icon_list/trash-701e84b0ebb8b4f17e6ac5f3f6a99b07.svg";